import { API_BASE, SESSIONS_API_BASE } from '../config/apiBase';
// src/config/appConfig.js

// Central configuration for the DVA application
export const AppConfig = {
  // ============================================================
  // CLIENT ID: No default - must come from AuthContext session
  // Components should use: const { session } = useAuth();
  //                        const clientId = session?.client_id;
  // ============================================================
  DEFAULT_CLIENT_ID: null, // Intentionally null - use session.client_id

  // API configuration
  API_BASE_URL: API_BASE,
  BACKEND_URL: API_BASE,
  SESSIONS_API_URL: SESSIONS_API_BASE,

  // Feature flags
  features: {
    enableExport: true,
    enableAIGeneration: true,
  },

  // Client configurations - keys are STRINGS for BigQuery compatibility
  clients: {
    '200': { name: 'UPMC', type: 'Health System' },
    '101': { name: 'Sample Health System', type: 'Health System' },
    '102': { name: 'Demo Hospital', type: 'Hospital' },
    '300': { name: 'North Star Consortium', type: 'Health System' }
  }
};

// Simple constant for easy import - uses primary API URL
export const API_URL = AppConfig.API_BASE_URL;

// Helper function to build API endpoint URLs
export const buildApiUrl = (path) => {
  // Remove leading slash if present to avoid double slashes
  const cleanPath = path.startsWith('/') ? path : `/${path}`;
  return `${API_URL}${cleanPath}`;
};

// Helper function to build session API endpoint URLs
export const buildSessionApiUrl = (path) => {
  // Remove leading slash if present to avoid double slashes
  const cleanPath = path.startsWith('/') ? path : `/${path}`;
  return `${AppConfig.SESSIONS_API_URL}${cleanPath}`;
};

// ============================================================
// DEPRECATED: These helpers should NOT be used for new code.
// Instead, get clientId directly from AuthContext:
//   const { session } = useAuth();
//   const clientId = session?.client_id;
// ============================================================

/**
 * @deprecated Use AuthContext session.client_id instead
 * Get client ID from URL params - returns STRING or null (no silent fallback)
 */
export const getClientId = (urlParams) => {
  const clientId = urlParams?.clientId;
  if (!clientId) {
    console.warn('⚠️ getClientId called without clientId - use AuthContext session.client_id instead');
    return null;
  }
  return String(clientId); // Always return string for BigQuery compatibility
};

/**
 * @deprecated Use AuthContext session.client_id instead
 * Get client ID as string from URL params
 */
export const getClientIdString = (urlParams) => {
  return getClientId(urlParams);
};

/**
 * Get client info by ID (accepts string or number, normalizes to string lookup)
 */
export const getClientInfo = (clientId) => {
  if (!clientId) {
    return { name: 'Unknown Client', type: 'Unknown' };
  }
  const id = String(clientId);
  return AppConfig.clients[id] || { name: `Client ${id}`, type: 'Unknown' };
};